import Demetra from '@adoratorio/demetra';

const demetra = {
  ref: null,

  init(lang) {
    demetra.ref = new Demetra({
      endpoint: 'https://zonin-prosecco.adorator.io/api.php',
      lang,
      debug: false,
    });
  },
};

export default demetra;
